import { compose, withFieldValidation } from "@transformd-ltd/sdk";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// UNIQUE TO NEOBANK FORM
const FIELD_ID = "64c9aae8b9cd4359eb0f39e3";
const FIELD_TAG = "termsModal";

function TermsModal(props) {
  const { getData, errorMessage } = props;
  const refModalBody = useRef(null);
  const elementModalBody = refModalBody?.current;

  const [show, setShow] = useState(false);
  const [hasFullyScrolled, setHasFullyScrolled] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleAccept = () => {
    getData().setFieldValue(FIELD_ID, "I Agree");
    document.querySelector("#transformd").classList.add("dummy-class"); // Dummy data -- need to modify the DOM to trigger mutation observer
    setShow(false);
  };

  const handleDecline = () => {
    setShow(false);
  };

  const handleScrollBody = (e) => {
    const totalScrollableHeight = e.target.scrollHeight - e.target.scrollTop;
    const clientHeight = e.target.clientHeight;
    // console.log("scrollHeight", e.target.scrollHeight);
    // console.log("scrollTop", e.target.scrollTop);
    // console.log("clientHeight", e.target.clientHeight);
    // console.log(
    //   "boolean evaluation",
    //   totalScrollableHeight <= clientHeight + 10
    // );

    if (totalScrollableHeight <= clientHeight + 10) {
      setHasFullyScrolled(true);
    }
  };

  // On render of the modal body, checks if the T&Cs is fully visible (onScroll will NEVER trigger)
  useEffect(() => {
    const modalBodyElement = refModalBody?.current;
    if (modalBodyElement && show) {
      // console.log("__INIT: Trigger scroll check");
      handleScrollBody({ target: modalBodyElement }); // Forcibly trigger the scroll handler, as it will NEVER trigger if the element has no scroll due to being fully visible on large screens
      // console.log("__DONE: Trigger scroll check");
    } else {
      // console.log("show", show, refModalBody);
    }
  }, [refModalBody, show]);

  const fieldIsIncomplete = !getData().getFieldValue(FIELD_ID);

  return (
    <React.Fragment>
      <div
        className="terms-btn-container"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "start",
          paddingRight: 40,
          // marginTop: 20,
        }}
      >
        <Button
          variant="outline-primary"
          onClick={handleShow}
          // style={{ marginTop: 24 }}
        >
          Terms & Conditions
        </Button>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            ref={refModalBody}
            style={{
              maxHeight: "60vh",
              overflowX: "hidden",
              overflowY: "auto",
            }}
            onScroll={handleScrollBody}
          >
            <p>
              <b>
                Registration of Visa Debit Card and eStatements applying online
                to be a Police Bank Member
              </b>
            </p>
            <p>
              When applying online to become a member of Police Bank, this
              information explains your rights and our responsibilities in
              conjunction with the Access Methods Terms and Conditions found on
              the Police Bank website (
              <a href="http://www.policebank.com.au">www.policebank.com.au</a>)
            </p>
            <p>
              When you have completed the Police Bank member application online
              and subject to our eligibility criteria being met, you will be
              issued with a Police Bank Visa Debit Card (referred to as the
              'Visa Debit Card') to provide access to the following accounts
              held by you as the account holder (referred to as the 'nominated
              accounts'):
            </p>
            <ul>
              <li>
                The Easy Access Account or Safeguard Account (collectively known
                as The Easy Access Account)
              </li>
              <li>The U30 SUPER CHARGE account</li>
            </ul>
            <p>
              This Visa Debit Card provides access to funds anywhere in the
              world through ATM and EFTPOS facilities as well as withdrawals
              over the counter at institutions displaying the Visa symbol.
            </p>
            <p>
              After you have been on-boarded as a member of Police Bank, you may
              continue using your Visa Debit Card or cancel the facility.{" "}
            </p>
            <p>
              Furthermore, by becoming a member of Police Bank using the on-line
              application process, you will be automatically registered as a
              subscriber to eStatements (electronic statements) on your
              nominated account. However, you if you wish to cancel eStatements
              and/or if your account is ineligible for eStatements, you will be
              issued with a paper statement which will be sent to your nominated
              mailing address.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDecline}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={handleAccept}
            disabled={!hasFullyScrolled}
          >
            I agree to the terms & conditions
          </Button>
        </Modal.Footer>
      </Modal>
      {errorMessage && fieldIsIncomplete ? (
        <div className="formatic-error-message">
          Please accept the terms & conditions in order to continue
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

export default compose(withFieldValidation)(TermsModal);
